import { lazy } from 'react';
const cachedLazyComponents = {};
export const noCacheKeyError = new Error('"cacheKey" must be specified.');
export default function lazyLoad(loader, cacheKey) {
  // cacheKey is required
  if (!cacheKey) {
    throw noCacheKeyError;
  }

  // create a new lazy component and cache it if cached component not exists
  if (!cachedLazyComponents[cacheKey]) {
    const LazyComponent = /*#__PURE__*/lazy(loader);
    LazyComponent.load = loader;
    cachedLazyComponents[cacheKey] = LazyComponent;
  }
  return cachedLazyComponents[cacheKey];
}